export default function getResource(label, vars = []) {
    const resources = {
        purchased: 'Acheté',
        time: 'fois',
        times: 'fois',
        lastPurchase: 'Dernier achat :'
    };
    return resources[label];
}
